<template>
  <ChevronUp
    class="text-blue transition-transform"
    :class="{ 'transform rotate-180': !open }"
  />
</template>

<script setup lang="ts">
import ChevronUp from 'vue-material-design-icons/ChevronUp.vue'

defineProps<{
  open: boolean
}>()
</script>
